import { render } from "./GovernanceDashboard.vue?vue&type=template&id=c757f7ea"
import script from "./GovernanceDashboard.vue?vue&type=script&lang=js"
export * from "./GovernanceDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__